import { status } from "nprogress";
import { faYenSign } from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";

export default {
  comparison: {
    contain: 'Có chứa',
    does_not_contain: 'Không chứa',
    s_equal: 'Bằng',
    s_does_not_equal: 'Khác',
    equal: 'Bằng',
    does_not_equal: 'Khác',
    greater_than: 'Lớn hơn',
    greater_than_or_equal: 'Lớn hơn hoặc bằng',
    less_than: 'Nhỏ hơn',
    less_than_or_equal: 'Nhỏ hơn hoặc bằng',
    in: 'Bằng',
    not_in: 'Khác',
    d_equal: 'Bằng',
    d_does_not_equal: 'Khác',
    d_greater_than: 'Lớn hơn',
    d_greater_than_or_equal: 'Lớn hơn hoặc bằng',
    d_less_than: 'Nhỏ hơn',
    d_less_than_or_equal: 'Nhỏ hơn hoặc bằng',
  },
  receive_type: {
    xep_xe: 'Đã bốc hàng',
    ha_hang: 'Đã hạ hàng',
  },
  bill_status: {
    chua_xuat: 'Chưa xuất',
    da_xuat: 'Đã xuất',
    da_thanh_toan: 'Đã thanh toán',
  },
  price_type: {
    tu_dong: 'Tự động',
    theo_can: 'Theo cân',
    theo_khoi: 'Theo khối',
  },
  product_status: {
    nhap_kho_tq: 'Nhập kho TQ',
    cho_xep_xe: 'Chờ xếp xe',
    xep_xe: 'Đã bốc hàng',
    cho_thong_quan_tq: 'Chờ thông quan TQ',
    kiem_hoa: 'Kiểm hóa',
    cho_thong_quan_vn: 'Chờ thông quan VN',
    nhap_kho_vn: 'Đã hạ hàng',
    xuat_thieu: 'Xuất thiếu',
    xuat_du: 'Xuất đủ',
  },
  order_status: {
    all: 'Tất cả',
    cancel: 'Hủy đơn hàng',
    quote_pending: 'Chờ báo giá',
    deposit_pending: 'Chờ đặt cọc',
    deposited: 'Đã đặt cọc',
    purchased: 'Đã mua hàng',
    shop_shipped: 'Shop phát hàng',
    cn_warehouse: 'Đã nhập kho TQ',
    vn_shipping: 'Vận chuyển về VN',
    vn_warehouse: 'Đã nhập kho VN',
    exported: 'Đã xuất kho',
    complaint: 'Khiếu nại',
    completed: 'Hoàn thành'
  },
  order_deposit_status: {
    cancel: 'Hủy đơn hàng',
    shop_shipped: 'Shop phát hàng',
    cn_warehouse: 'Đã nhập kho TQ',
    vn_shipping: 'Vận chuyển về VN',
    vn_warehouse: 'Đã nhập kho VN',
    payment_pending: 'Chờ thanh toán',
    exported: 'Đã xuất kho',
    completed: 'Hoàn thành'
  },
  package_status: {
    not_shipped: 'Chưa phát hàng',
    shipping: 'Đang vận chuyển',
    cn_warehouse: 'Đã về kho TQ',
    vn_shipping: 'Đang chuyển về VN',
    vn_warehouse: 'Đã về kho VN',
    delivered: 'Đã giao hàng'
  },
  big_package: {
    headers: {
      package_code: 'Mã lô',
      big_export_id: 'Mã PX',
      status: 'Trạng thái',
      store_exp_id: 'Kho nhận',
      product_name: 'Tên hàng',
      number_of_pack: 'Tổng mã',
      total_small_pack: 'Tổng kiện',
      weight: 'Tổng cân',
      volume: 'Tổng khối',
      amount: 'Cước phí',
      phone_number: 'Điện thoại',
      address: 'Địa chỉ',
      store_phone_number: 'BS.Xe',
      ex_date: 'Xuất kho TQ',
      im_date: 'Nhập kho VN',
      state: 'Tình trạng',
      payment_status: 'Thanh toán',
      created_by: 'Người tạo',
      note: 'Ghi chú',
      action: 'Thao tác'
    }
  },
  profit_stats: {
    headers: {
      staff: 'Nhân viên',
      completed_orders: 'Số đơn hoàn thành',
      completed_links: 'Số link hoàn thành',
      total_order_amount: 'Tổng tiền đơn hàng',
      total_real_amount: 'Tổng tiền mua thật',
      total_diff: 'Tổng chênh lệch',
      total_completed_order_amount: 'Tổng tiền đơn HT',
      total_completed_real_amount: 'Tổng tiền mua thật HT',
      total_completed_diff: 'Tổng chênh lệch HT',
      reward: 'Thưởng'
    }
  },
  dialog: {
    product_detail_title: 'Chi tiết mã vận đơn',
    cost_tax_info: 'Thông tin chi phí & thuế',
    select_export_type: 'Chọn loại file xuất',
    edit_quote_info: 'Chỉnh sửa thông tin báo giá',
  },
  form: {
    name: 'Tên',
    email: 'Email',
    phone: 'Số điện thoại',
    address: 'Địa chỉ',
    status: 'Trạng thái',
    date: 'Ngày',
    time: 'Thời gian',
    amount: 'Số tiền',
    quantity: 'Số lượng',
    weight: 'Cân nặng',
    note: 'Ghi chú',
    description: 'Mô tả',
    select_customer: 'Chọn khách hàng',
    select_storage: 'Kho nhận',
    partner_name: 'Tên khách',
    select_quote: 'Chọn báo giá',
    no_name: 'Không có tên',
    no_quote: 'Không có báo giá nào',
    select_customer_first: 'Vui lòng chọn khách hàng trước',
    notice_save_product: 'Vui lòng lưu sản phẩm trước khi thêm kiện hàng!',
    hs_code: 'Mã HS',
    total_amount: 'Tổng tiền',
    created_date: 'Ngày tạo',
    product_name_cn: 'Tên sản phẩm',
    product_type: 'Loại hàng',
    suffix_bill: 'Mã vận đơn Wuliu',
    transaction_deposit: 'Ship nội địa (¥)',
    pedicab_deposit: 'Chi xe kéo (¥)',
    load_deposit: 'Chi xe nâng (¥)',
    other_fee: 'Phí khác (¥)',
    exchange_rate: 'Tỷ giá',
    weight: 'Tổng cân',
    volume: 'Tổng khối',
    number_of_pack: 'Tổng kiện',
    note: 'Ghi chú',
    price_type: 'Cách tính phí',
    weight_price: 'Giá cân',
    volume_price: 'Giá khối',
    weight_cost: 'Giá cân gốc',
    volume_cost: 'Giá khối gốc',
    product_amount: 'Tiền hàng (đ)',
    import_tax_rate: 'Thuế nhập khẩu (%)',
    vat_tax_rate: 'Thuế VAT (%)',
    service_fee_rate: 'Phí dịch vụ (%)',
    import_tax_amount: 'Thuế nhập khẩu (đ)',
    vat_tax_amount: 'Thuế VAT (đ)',
    service_fee_amount: 'Phí dịch vụ (đ)',
    self_fee: 'Phí phát sinh (đ)',
    self_fee_note: 'Ghi chú phát sinh',
    subtotal: 'Thành tiền',
    total_profit: 'Lợi nhuận (đ)',
    is_linked: '(Đã liên kết đơn)',
    image: 'Hình ảnh',
    length: 'Dài',
    width: 'Rộng',
    height: 'Cao',
    export_tieu_ngach: 'Xuất file tiểu ngạch',
    export_chinh_ngach: 'Xuất file chính ngạch TQ',
    export_chinh_ngach_vi: 'Xuất file chính ngạch VN',
    product_brand: 'Nhãn hiệu',
    product_capacity: 'Công suất / Dung tích',
    product_material: 'Chất liệu hàng',
    pack_type: 'Quy cách đóng gói',
    product_size: 'Kích thước sản phẩm',
    total_product: 'Tổng sản phẩm',
    yes: 'Có',
    no: 'Không',
  },
  actions: {
    close: 'Đóng',
    save: 'Lưu lại',
  },
  customer: {
    headers: {
      id: 'ID',
      username: 'Khách hàng',
      first_name: 'Họ',
      last_name: 'Tên',
      email: 'Email',
      phone: 'Điện thoại',
      address: 'Địa chỉ',
      level: 'Cấp độ',
      status: 'Trạng thái',
      purchase_name: 'Mua hàng',
      cs_name: 'CSKH',
      sale_name: 'Sale',
      price_id: 'Bảng giá',
      note: 'Ghi chú',
      total_transaction: 'Tích lũy',
      wallet: 'Số dư ví',
      created_date: 'Ngày tạo',
      modified_date: 'Ngày sửa',
      modified_by: 'Người sửa',
      action: 'Thao tác'
    }
  },
  // Order headers
  order: {
    headers: {
      order_id: 'Mã đơn',
      product_image: 'Ảnh SP',
      total_amount: 'Tổng tiền',
      min_deposit: 'Cần cọc',
      customer: 'Khách hàng',
      buyer: 'Mua hàng',
      cs: 'CSKH',
      sale: 'Sale',
      note: 'Lưu ý',
      status: 'Trạng thái',
      action: 'Thao tác',
      select_customer: 'Chọn khách hàng',
      select_storage: 'Chọn kho nhận',
      partner_name: 'Tên khách',
      select_quote: 'Chọn báo giá',
      no_name: 'Không có tên',
      no_quote: 'Không có báo giá nào',
      select_customer_first: 'Vui lòng chọn khách hàng trước',
      hs_code: 'Mã HS',
      total_amount: 'Tổng tiền',
      created_date: 'Ngày tạo',
      product_name_cn: 'Tên sản phẩm',
      product_type: 'Loại hàng',
      suffix_bill: 'Mã vận đơn Wuliu',
      transaction_deposit: 'Ship nội địa (¥)',
      pedicab_deposit: 'Chi xe kéo (¥)',
      load_deposit: 'Chi xe nâng (¥)',
      other_fee: 'Phí khác (¥)',
      exchange_rate: 'Tỷ giá',
      volume: 'Tổng khối',
      number_of_pack: 'Tổng kiện',
      price_type: 'Cách tính phí',
      weight_price: 'Giá cân',
      volume_price: 'Giá khối',
      weight_cost: 'Giá cân gốc',
      volume_cost: 'Giá khối gốc',
      product_amount: 'Tiền hàng (đ)',
      import_tax_rate: 'Thuế nhập khẩu (%)',
      vat_tax_rate: 'Thuế VAT (%)',
      service_fee_rate: 'Phí dịch vụ (%)',
      import_tax_amount: 'Thuế nhập khẩu (đ)',
      vat_tax_amount: 'Thuế VAT (đ)',
      service_fee_amount: 'Phí dịch vụ (đ)',
      self_fee: 'Phí phát sinh (đ)',
      self_fee_note: 'Ghi chú phát sinh',
      total_profit: 'Lợi nhuận (đ)',
      image: 'Hình ảnh',
      choose_file: 'Chọn file',
      no_file_chosen: 'Chưa chọn file nào',
      add: 'Thêm',
      length: 'Dài',
      width: 'Rộng',
      height: 'Cao',
      weight_sub: 'Cân nặng',
      number_of_pack_sub: 'Số kiện',
      no_data: 'Không có dữ liệu',
      support_staff: 'Nhân viên hỗ trợ',
      wooden_pack: 'Đóng gỗ',
      check_goods: 'Kiểm hàng',
      guarantee: 'Bảo hiểm',
      created_date: 'Ngày lên đơn',
      deposit_date: 'Ngày cọc đơn',
      bought_date: 'Ngày mua hàng',
      shop_deliver_date: 'Ngày phát hàng',
      store_cn_im_date: 'Nhập kho TQ',
      store_cn_ex_date: 'Xuất kho TQ',
      store_vn_im_date: 'Nhập kho VN',
      payment_date: 'Ngày thanh toán',
      completed_date: 'Ngày hoàn thành'
    }
  },
  // PaymentHistory headers
  payment_history: {
    headers: {
      id: 'ID',
      order_id: 'Mã đơn hàng',
      amount: 'Số tiền',
      customer: 'Khách hàng',
      type: 'Loại giao dịch',
      created_date: 'Ngày tạo',
      created_by: 'Người tạo'
    }
  },
  // ProductType headers
  product_type: {
    headers: {
      id: 'ID',
      name: 'Tên loại hàng',
      active: 'Sử dụng',
      active_true: 'Sử dụng',
      active_false: 'Không sử dụng',
      modified_date: 'Ngày sửa',
      modified_by: 'Người sửa',
      action: 'Thao tác'
    }
  },
  // CustomerLevel headers
  customer_level: {
    headers: {
      name: 'Tên cấp độ',
      discount_fee_buy: 'CK phí mua hàng',
      discount_fee_weight: 'CK phí cân nặng',
      min_deposit: 'Đặt cọc tối thiểu',
      action: 'Thao tác'
    }
  },
  // DebtReport headers
  debt_report: {
    headers: {
      customer: 'Khách hàng',
      deposit: 'Tiền nạp',
      order_amount: 'Tiền hàng',
      wallet: 'Dư ví',
      wallet_theory: 'Dư ví lý thuyết',
      debt_arrived: 'Công nợ đơn đã về',
      debt_not_arrived: 'Công nợ đơn chưa về',
      note: 'Ghi chú'
    },
    debt_in: "Công nợ phải thu",
    debt_out: "Công nợ phải trả",
    total_debt: "Tổng công nợ",
  },
  // Header và Navigation
  navigation: {
    dashboard: 'Trang chủ',
    orders: 'Đơn hàng',
    packages: 'Kiện hàng',
    customers: 'Khách hàng',
    reports: 'Báo cáo',
    settings: 'Cài đặt',
    logout: 'Đăng xuất'
  },

  wallet_history: {
    headers: {
      id: 'ID',
      customer: 'Khách hàng',
      trade_type: 'Loại giao dịch',
      amount: 'Số tiền',
      balance: 'Số dư',
      content: 'Nội dung',
      note: 'Ghi chú',
      created_date: 'Ngày tạo',
      created_by: 'Người tạo'
    }
  },

  dashboard: {
    order_title: 'Đơn mua hộ',
    deposit_title: 'Đơn ký gửi',
    list_bigpackages: 'Danh sách lô hàng',
  },

  // Route titles
  routes: {
    profile: 'Tài khoản',
    dashboard: 'Bảng điều khiển',
    orders: 'Đơn hàng',
    order_detail: 'Đơn hàng',
    orders_late_delivery: 'Chậm phát hàng',
    orders_late_china_warehouse: 'Chậm nhập kho TQ',
    orders_late_vn_warehouse: 'Chậm nhập kho VN',
    orders_late_customer: 'Chậm trả khách',
    orders_late_purchase: 'Chậm mua hàng',
    customers: 'Khách hàng',
    customer_detail: 'Khách hàng',
    transaction_history: 'Lịch sử giao dịch',
    deposit: 'Nạp tiền',
    deposit_detail: 'Nạp tiền',
    admin_deposit: 'Nạp tiền',
    payment_history: 'Lịch sử thanh toán',
    withdrawal: 'Rút tiền',
    payment_goods: 'Thanh toán tiền hàng',
    payment_detail: 'Thanh toán tiền hàng',
    tracking_code: 'Mã vận đơn',
    consignment: 'Ký gửi',
    consignment_detail: 'Ký gửi',
    consignment_late_china: 'Chậm nhập kho TQ',
    consignment_late_vn: 'Chậm nhập kho VN',
    consignment_late_customer: 'Chậm trả khách',
    complaints: 'Khiếu nại',
    complaint_detail: 'Khiếu nại',
    china_warehouse: 'Xuất nhập kho TQ',
    vn_warehouse_import: 'Nhập kho VN',
    vn_warehouse_detail: 'Nhập kho VN',
    shipment: 'Lô hàng',
    warehouse_export: 'Xuất kho',
    order_control: 'Kiểm soát đơn hàng',
    cash_flow_yuan: 'Luồng thu chi (¥)',
    cash_flow_yuan_detail: 'Chi tiết thu/chi (¥)',
    cash_flow_vnd: 'Luồng thu chi (₫)',
    cash_flow_vnd_detail: 'Chi tiết thu/chi (₫)',
    shop_refund: 'Shop hoàn tiền KN',
    refund_detail: 'Chi tiết hoàn tiền',
    quotes: 'Báo giá',
    quote_detail: 'Chi tiết báo giá',
    shipping_fee_original: 'Phí vận chuyển gốc',
    weight_fee: 'Phí cân nặng',
    weight_fee_detail: 'Phí cân nặng',
    volume_fee: 'Phí khối',
    volume_fee_detail: 'Phí khối',
    checking_fee: 'Phí kiểm đếm',
    checking_fee_detail: 'Phí kiểm đếm',
    insurance_fee: 'Phí bảo hiểm',
    insurance_fee_detail: 'Phí bảo hiểm',
    buying_fee: 'Phí mua hộ',
    buying_fee_detail: 'Phí mua hộ',
    guarantee_fee: 'Phí bảo lãnh',
    guarantee_fee_detail: 'Phí bảo lãnh',
    reinforcement_fee: 'Phí gia cố',
    reinforcement_fee_detail: 'Phí gia cố',
    address_book: 'Sổ địa chỉ',
    address_book_detail: 'Sổ địa chỉ',
    china_stores: 'Shop Trung Quốc',
    china_store_detail: 'Shop Trung Quốc',
    configurations: 'Cấu hình',
    configuration_detail: 'Cấu hình',
    user_management: 'Quản lý người dùng',
    user_detail: 'Quản lý người dùng',
    notification_management: 'Quản lý thông báo',
    notification_detail: 'Quản lý thông báo',
    customer_level: 'Cấp độ khách hàng',
    customer_level_detail: 'Cấp độ khách hàng',
    media: 'Media',
    daily_report: 'Báo cáo ngày',
    monthly_report: 'Báo cáo tháng',
    customer_report: 'Báo cáo khách hàng',
    debt_report: 'Báo cáo công nợ',
    purchase_report: 'Báo cáo mua hàng',
    warehouse_report: 'Báo cáo kho',
    product_type: 'Loại hàng',
    partner: 'Đối tác',
    general_config: 'Cấu hình chung',
    staff: 'Nhân viên',
    vip_customer: 'Khách hàng thân thiết',
    china_warehouse_config: 'Kho TQ',
    vn_warehouse_config: 'Kho VN',
    shipping_price_list: 'Bảng giá vận chuyển',
    hashtag: 'Hashtag',
    notification: 'Thông báo',
    profit_report: 'Báo cáo lợi nhuận',
    order_profit_stats: 'Thống kê lợi nhuận đặt hàng',
    buying_fee_stats: 'Thống kê phí mua hàng',
    shipping_fee_stats: 'Thống kê phí vận chuyển',
    currency_stats: 'Thống kê tiền tệ',
    finance: 'Tài chính',
    deposit_stats: 'Thống kê nạp tiền',
    revenue_report: 'Doanh thu',
    debt_report_detail: 'Báo cáo công nợ khách hàng',
    staff_commission_stats: 'Thống kê hoa hồng nhân viên',
    shipment_report: 'Báo cáo lô hàng',
    china_warehouse_export: 'Xuất kho TQ',
    payment_service: 'Thanh toán hộ',
    china_warehouse_finance: 'Thu chi kho TQ',
    china_warehouse_finance_detail: 'Chi tiết thu chi',
    order_hashtag: 'Hashtag đơn hàng',
    delivery_request: 'Yêu cầu giao hàng',
    delivery_request_detail: 'Chi tiết yêu cầu giao hàng',
    inventory_pending: 'Tồn kho chưa giao',
    lost_items: 'Hàng thất lạc',
    receiving_warehouse: 'Kho nhận',
    reports: 'Báo cáo',
    settings: 'Cài đặt',
    accountant: 'Kế toán',
    price_table: 'Bảng giá',
    payservice_report: 'Báo cáo thanh toán hộ',
    business_report: 'Báo cáo kết quả hoạt động kinh doanh',
    product_inventory: 'Hàng tồn',
    truck: 'Xếp xe',
    all: 'Tất cả',
    import_tq: 'Nhập kho TQ',
    waiting_for_truck: 'Chờ xếp xe',
    on_the_way: 'Đã xếp xe',
    processing_tq: 'Chờ thông quan TQ',
    check: 'Kiểm hóa',
    processing_vn: 'Chờ thông quan VN',
    import_vn: 'Nhập kho VN',
    exported: 'Đã xuất kho',
    no_owner: 'Hàng không tên',
    product_inventory_in_tq: 'Tồn kho TQ',
    product_inventory_in_vn: 'Tồn kho VN',
    truck_detail: 'Chi tiết xếp xe',
    bill_detail: 'Chi tiết xuất kho',
  },

  // Common actions
  actions: {
    save: 'Lưu',
    cancel: 'Hủy',
    delete: 'Xóa',
    edit: 'Sửa',
    add: 'Thêm',
    search: 'Tìm kiếm',
    filter: 'Lọc',
    export: 'Xuất',
    import: 'Nhập',
    refresh: 'Làm mới',
    submit: 'Gửi',
    confirm: 'Xác nhận',
    close: 'Đóng',
    view: 'Xem',
    update: 'Cập nhật',
    create: 'Tạo',
    print: 'In',
    print_label: 'In nhãn',
    edit_quote: 'Chỉnh sửa báo giá',
    export_file: 'Xuất file'
  },

  // Status
  status: {
    active: 'Hoạt động',
    inactive: 'Không hoạt động',
    pending: 'Chờ xử lý',
    completed: 'Hoàn thành',
    cancelled: 'Đã hủy',
    processing: 'Đang xử lý'
  },

  // Messages
  messages: {
    success: 'Thành công',
    error: 'Có lỗi xảy ra',
    warning: 'Cảnh báo',
    info: 'Thông tin',
    confirm_delete: 'Bạn có chắc chắn muốn xóa?',
    save_success: 'Lưu thành công',
    delete_success: 'Xóa thành công',
    update_success: 'Cập nhật thành công',
    no_data: 'Không có dữ liệu'
  },

  // Export messages
  export: {
    export_selected_items: 'Xuất {count} sản phẩm đã chọn',
    export_all_items: 'Xuất tất cả sản phẩm theo bộ lọc hiện tại',
    send_custom: 'Gửi khai báo hải quan'
  },

  // Validation messages
  validation: {
    product_brand_required: 'Nhãn hiệu là bắt buộc'
  },

  // Error messages
  errors: {
    product_no_quote: 'Sản phẩm này chưa có báo giá',
    cannot_load_quote_info: 'Lỗi khi tải thông tin báo giá',
    cannot_update_quote: 'Lỗi khi cập nhật thông tin báo giá'
  },

  // Success messages
  success: {
    quote_updated: 'Đã cập nhật thông tin báo giá thành công!'
  },

  // Order management
  orders: {
    title: 'Quản lý đơn hàng',
    order_code: 'Mã đơn hàng',
    customer_name: 'Tên khách hàng',
    order_date: 'Ngày đặt hàng',
    total_amount: 'Tổng tiền',
    shipping_fee: 'Phí vận chuyển',
    product_name: 'Tên sản phẩm',
    unit_price: 'Đơn giá',
    create_order: 'Tạo đơn hàng',
    order_details: 'Chi tiết đơn hàng'
  },

  // Package management 
  packages: {
    title: 'Quản lý kiện hàng',
    package_code: 'Mã kiện hàng',
    tracking_number: 'Mã vận đơn',
    sender: 'Người gửi',
    receiver: 'Người nhận',
    weight: 'Cân nặng',
    dimensions: 'Kích thước',
    shipping_cost: 'Phí vận chuyển',
    create_package: 'Tạo kiện hàng'
  },

  // Customer management
  customers: {
    title: 'Quản lý khách hàng',
    customer_code: 'Mã khách hàng',
    full_name: 'Họ và tên',
    phone_number: 'Số điện thoại',
    email_address: 'Địa chỉ email',
    address: 'Địa chỉ',
    registration_date: 'Ngày đăng ký',
    customer_level: 'Cấp độ khách hàng',
    create_customer: 'Tạo khách hàng'
  },

  // Language
  language: {
    vietnamese: 'Tiếng Việt',
    chinese: 'Tiếng Trung',
    select_language: 'Chọn ngôn ngữ'
  },
  accountant_cumulation: {
    headers: {
      accountant_date: 'Ngày',
      first_cumulation: 'Tồn đầu kỳ',
      income_amount: 'Thu',
      tuikuan: 'Tuikuan',
      outcome_purchase: 'Chi mua hàng',
      outcome_other: 'Chi khác',
      cumulation: 'Tồn cuối kỳ',
      note: 'Ghi chú',
      action: 'Thao tác',
      total: 'Tổng'
    }
  },

  // Common table headers - Tiêu đề bảng chung
  table_headers: {
    suffix_bill: 'Mã vận đơn Wuliu',
    deposit: 'Tổng chi(¥)',
    total_fee_weight: 'Tổng phí cân nặng',
    import_tax_amount: 'Thuế nhập khẩu',
    vat_tax_amount: 'Thuế VAT',
    total_cost_weight: 'Tổng chi phí cân nặng',
    total_profit: 'Tổng lợi nhuận',
    receive_date: 'Ngày nhận',
    deliver_date: 'Ngày giao',
    store_id: 'Kho nhận',
    id: 'ID',
    username: 'User Name',
    partner_name: 'Tên đối tác',
    order_codes: 'Mã đơn hàng',
    bill_codes: 'Mã bill',
    email: 'Email',
    full_name: 'Họ tên',
    first_name: 'Họ',
    last_name: 'Tên',
    phone: 'Điện thoại',
    address: 'Địa chỉ',
    status: 'Trạng thái',
    action: 'Thao tác',
    created_date: 'Ngày tạo',
    modified_date: 'Ngày sửa',
    modified_by: 'Người sửa',
    created_by: 'Người tạo',
    note: 'Ghi chú',
    is_split_tax: 'Tách thuế',

    // Customer headers
    customer_code: 'Mã khách hàng',
    customer_name: 'Tên khách hàng',
    customer: 'Khách hàng',
    total_deposit: 'Tổng nạp',
    order_amount: 'Tiền hàng',
    debt: 'Công nợ',
    sale_staff: 'Nhân viên sale',
    level: 'Cấp độ',
    role: 'Quyền hạn',

    // Quote headers
    quote_id: 'Mã báo giá',
    product_image: 'Hình ảnh hàng',
    product_info: 'Tên loại hàng',
    customs_content: 'Yêu cầu khai báo',
    customs_price_note: 'Thuế & giá khai báo',
    customs_unit: 'Đơn vị khai báo',
    hs_code: 'Mã HS',
    product_number: 'Số lượng sản phẩm',
    customs_price_vnd: 'Giá cần khai báo',
    import_tax: 'Thuế nhập khẩu (%)',
    vat_tax: 'VAT (%)',
    service_fee: 'Phí dịch vụ (%)',
    number_of_pack: 'Số kiện',
    weight: 'Cân nặng',
    volume: 'Thể tích',
    is_quoted: 'Trạng thái',

    // Product/Tracking headers
    tracking_code: 'Mã vận đơn',
    product_name: 'Tên hàng',
    product_name_cn: 'Tên hàng TQ',
    product_name_vn: 'Tên hàng VN',
    package_code: 'Mã bao',
    bill_code: 'Bill',
    bill_id: 'Mã bill',
    total_cost_yuan: 'Tổng chi (¥)',
    cost_yuan: 'Chi tệ',
    shipping_fee_yuan: 'P.Ship (¥)',
    shipping_fee: 'Phí ship',
    shipping_cost: 'Phí vận chuyển',
    cn_warehouse_date: 'Nhập kho TQ',
    package_date: 'Đóng bao',
    vn_warehouse_date: 'Nhập kho VN',
    export_date: 'Xuất kho VN',
    remaining_pack: 'Kiện tồn',

    // Storage/Warehouse headers
    storage_name: 'Tên kho',
    storage_cn: 'Kho TQ',
    storage_vn: 'Kho nhận',
    available: 'Khả dụng',

    // Product Type headers
    product_type_name: 'Tên loại hàng',
    product_type: 'Loại hàng',

    // Fee headers
    fee_from_kg: 'Từ (kg)',
    fee_to_kg: 'Đến (kg)',
    fee_from_m3: 'Từ (m3)',
    fee_to_m3: 'Đến (m3)',
    unit_price: 'Đơn giá',
    price_kg: 'Giá kg',
    price_m3: 'Giá M3',

    // Payment headers
    amount: 'Số tiền',
    total_amount: 'Tổng tiền',
    shipping_fee_label: 'Tiền cước',
    other_fee: 'Phí khác',
    payment_date: 'Ngày thanh toán',
    content: 'Nội dung',

    // Recharge headers
    recharge_amount: 'Số tiền',
    trade_content: 'Nội dung giao dịch',

    // Truck headers
    truck_code: 'Mã hiệu',
    license_plate: 'Biển số xe',
    truck_date: 'Ngày xếp xe',
    warehouse_date: 'Ngày nhập kho',
    order_count: 'Số mã ĐH',
    load_truck: 'Xếp xe',
    export_warehouse: 'Xuất kho',

    // BigPackage headers
    big_package_code: 'Bao hàng',
    warehouse_code: 'Mã vào kho',
    package_count: 'Số gói',
    import_pack: 'Kiện nhập',
    import_kg: 'Kg nhập',
    import_m3: 'M3 nhập',

    // Report headers
    date: 'Ngày',
    bill_count: 'Số bill',
    pack_count: 'Số kiện',
    discount: 'Chiết khấu',
    subtotal: 'Thành tiền',
    cost: 'Chi phí',
    profit: 'Lợi nhuận',

    // Dimension headers
    length: 'Dài',
    width: 'Rộng',
    height: 'Cao',

    // Additional headers
    exchange_rate: 'Tỷ giá',
    original_weight_fee: 'Tiền cân gốc',
    import_tax_fee: 'Thuế nhập khẩu',
    vat_tax_fee: 'Thuế VAT',
    service_fee_amount: 'Phí dịch vụ',
    attributes: 'Thuộc tính',
    quantity: 'Số lượng',
    price_yuan: 'Giá (¥)',
    total_yuan: 'Thành tiền (¥)',
    s_pack: 'S.Kiện',
    kg: 'KG',
    m3: 'M3',
    number_of_code: 'Tổng bill',
    total_pack: 'Tổng kiện',
    total_weight: 'Tổng cân',
    total_volume: 'Tổng khối',
    total_deposit: 'Chi tệ',
    fee_ship_vnd: 'Phí ship',
    discount_amount: 'Chiết khấu',
    amount_vnd: 'Tổng tiền',
    line_amount: 'Thành tiền',
    paid_amount: 'Đã thanh toán',
    remaining_amount: 'Còn nợ',
    actions: 'Thao tác',
    is_hidden: 'Khả dụng',
    storage: 'Kho nhận',
    amount_weight: 'Giá cân',
    amount_volume: 'Giá khối'
  }
}